import { render, staticRenderFns } from "./MtsTakipAcIslemDetayView.vue?vue&type=template&id=3bef7d7a&scoped=true"
import script from "./MtsTakipAcIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./MtsTakipAcIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef7d7a",
  null
  
)

export default component.exports